export const compare247 = {
  nav: {
    categories: 'Categories',
    compare: 'Compare',
    blog: 'Knowledge',
    about: 'About'
  },
  hero: {
    title: 'Smart Digital Tools Comparison',
    subtitle: 'Make the Right Decision from the Start',
    description: 'Compare247 – neutral comparison & consulting platform 24/7. No sales, no hidden ads, just transparent information for your own decision.',
    cta: 'Start Comparing',
    searchPlaceholder: 'Search tools, platforms...'
  },
  categories: {
    title: 'Comparison Categories',
    subtitle: 'Choose your area of interest',
    ai: {
      title: 'AI & Technology',
      desc: 'Compare AI image, video, content and website generators',
      tools: '50+ tools'
    },
    saas: {
      title: 'Software & SaaS',
      desc: 'CRM, Email marketing, SEO tools and automation',
      tools: '80+ platforms'
    },
    marketing: {
      title: 'Marketing & Advertising',
      desc: 'Google Ads tools, tracking, spy and affiliate',
      tools: '40+ tools'
    },
    finance: {
      title: 'Digital Finance',
      desc: 'Crypto exchanges, forex, prop trading - neutral reviews',
      tools: '60+ platforms'
    },
    platform: {
      title: 'Digital Platforms',
      desc: 'Freelancer, remote work, cloud storage',
      tools: '35+ platforms'
    },
    hosting: {
      title: 'Website & Hosting',
      desc: 'Hosting, VPS, Domain and Website builders',
      tools: '45+ services'
    }
  },
  usp: {
    title: 'Why Choose Compare247',
    neutral: {
      title: 'Absolutely Neutral',
      desc: 'No bias, no manipulated reviews. Only objective information based on real research.'
    },
    transparent: {
      title: '100% Transparent',
      desc: 'Open about affiliate income. No priority for higher commission platforms.'
    },
    noPromise: {
      title: 'No Profit Guarantee',
      desc: 'No quick money promises. Just help you understand and make informed decisions.'
    },
    support: {
      title: '24/7 Support',
      desc: 'Always updated with latest information. Research team works continuously for accurate data.'
    }
  },
  featured: {
    title: 'Featured Comparisons',
    subtitle: 'Most popular comparison tables',
    viewComparison: 'View Comparison',
    platforms: 'platforms'
  },
  howItWorks: {
    title: 'How We Evaluate',
    subtitle: 'Compare247 research and comparison process',
    step1: {
      title: 'Deep Research',
      desc: 'Expert team thoroughly researches each platform: features, pricing, policies, real user reviews.'
    },
    step2: {
      title: 'Real Testing',
      desc: 'Hands-on experience with tools, testing performance, stability and customer support quality.'
    },
    step3: {
      title: 'Objective Analysis',
      desc: 'Compare based on clear criteria: value, features, reliability, suitability for different user types.'
    },
    step4: {
      title: 'Continuous Updates',
      desc: 'Monitor changes, update information, adjust reviews when platforms make significant changes.'
    }
  },
  testimonials: {
    title: 'What Users Say About Compare247',
    subtitle: 'Real feedback from the community',
    user1: {
      name: 'Michael Chen',
      role: 'Digital Marketer',
      content: 'Compare247 saves me hours of research. Clear information, no exaggeration, very helpful when choosing marketing tools.'
    },
    user2: {
      name: 'Sarah Johnson',
      role: 'Freelancer',
      content: 'I appreciate Compare247\'s neutrality. They don\'t try to sell, just provide information for me to decide.'
    },
    user3: {
      name: 'David Lee',
      role: 'Trader',
      content: 'The prop trading firm comparison is very detailed and objective. Helped me avoid unreliable platforms.'
    }
  },
  stats: {
    platforms: {
      number: '300+',
      label: 'Platforms Compared'
    },
    comparisons: {
      number: '150+',
      label: 'Detailed Comparisons'
    },
    users: {
      number: '50K+',
      label: 'Trusted Users'
    },
    updates: {
      number: '24/7',
      label: 'Continuous Updates'
    }
  },
  cta: {
    title: 'Ready to Find the Right Tool',
    subtitle: 'Start comparing today and make smart decisions',
    button: 'Explore Now',
    note: 'Free, no registration required'
  },
  footer: {
    tagline: 'Neutral digital tools comparison platform 24/7. Compare – Understand – Decide.',
    categories: 'Categories',
    company: 'Company',
    legal: 'Legal',
    contact: 'Contact',
    about: 'About',
    mission: 'Mission',
    team: 'Team',
    blog: 'Blog',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    disclaimer: 'Disclaimer',
    affiliate: 'Affiliate Disclosure',
    email: 'Email',
    phone: 'Phone',
    copyright: '© 2025 Compare247. All rights reserved.',
    poweredBy: 'Built by Readdy'
  },
  disclaimer: {
    title: 'Important Notice',
    affiliate: {
      title: 'Affiliate Disclosure',
      content: 'Compare247 may receive commission when you sign up or purchase products through our links. However, this does not affect our reviews. We are committed to maintaining neutrality and transparency in all comparisons.'
    },
    noGuarantee: {
      title: 'No Profit Guarantee',
      content: 'Compare247 does not guarantee any financial results from using the tools or platforms mentioned. All investment or service usage decisions are your responsibility.'
    },
    risk: {
      title: 'Risk Warning',
      content: 'Financial trading, crypto investment, forex and other financial products carry high risks. You may lose your entire investment. Research thoroughly and only invest money you can afford to lose.'
    },
    accuracy: {
      title: 'Information Accuracy',
      content: 'We strive to provide the most accurate information, but platforms may change policies and pricing without notice. Please verify information directly from providers before deciding.'
    }
  }
};
